/**
 * User preferences persisted in localStorage.
 *
 * Only NON-SENSITIVE convenience flags live here. The token, psk, session keys,
 * and any file data are never persisted — they exist in memory only and die
 * with the tab.
 */

export interface Settings {
  /** Auto-accept incoming files and save straight to Downloads (default on). */
  autoAccept: boolean;
}

const KEY = "enclave.settings";

const DEFAULTS: Settings = {
  autoAccept: true,
};

export function loadSettings(): Settings {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return { ...DEFAULTS };
    return { ...DEFAULTS, ...(JSON.parse(raw) as Partial<Settings>) };
  } catch {
    return { ...DEFAULTS };
  }
}

export function saveSettings(settings: Settings): void {
  localStorage.setItem(KEY, JSON.stringify(settings));
}

export function updateSetting<K extends keyof Settings>(
  key: K,
  value: Settings[K]
): Settings {
  const next = { ...loadSettings(), [key]: value };
  saveSettings(next);
  return next;
}
